module.exports = __webpack_public_path__ + "img/vbf.a75ea1b2.png";